import React from 'react';
import { m } from 'framer-motion';
import { CalendarIcon, ZapIcon, TargetIcon, DumbbellIcon, SmartphoneIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const bonuses = [{
  icon: CalendarIcon,
  emoji: '🗓️',
  title: 'Plan de Arranque en 7 Días',
  value: '9,90€',
  text: 'La hoja de ruta exacta para implementar el manual desde el primer día sin perderte entre 300 páginas. Te dice exactamente por dónde empezar según la edad y el nivel de tu equipo.'
}, {
  icon: ZapIcon,
  emoji: '⚡',
  title: 'Pack de 25 Calentamientos Inteligentes',
  value: '12,90€',
  text: 'Calentamientos con balón directamente conectados al objetivo de la sesión. Activan la concentración del grupo desde el primer minuto. Se acabó el "corred dos vueltas".'
}, {
  icon: TargetIcon,
  emoji: '🎯',
  title: 'Biblioteca de Juego Reducido',
  value: '14,90€',
  text: '30 situaciones de juego reducido (1v1, 2v1, 2v2, 3v3, 4v4) diseñadas para enseñar a tomar decisiones en tiempo real. El recurso más consultado por los entrenadores que ya tienen el manual.'
}, {
  icon: DumbbellIcon,
  emoji: '🏀',
  title: 'Ruedas de Finalización Profesional',
  value: '11,90€',
  text: '24 ejercicios de tiro y finalización organizados por tipo de jugador y nivel. Desde entradas básicas hasta pull-up bajo fatiga. El complemento perfecto para los últimos 15 minutos de cualquier sesión.'
}, {
  icon: SmartphoneIcon,
  emoji: '📱',
  title: 'Sistema de Entrenamientos Express',
  value: '9,90€',
  text: '20 sesiones diseñadas para los días que nada sale según lo previsto: media pista, 4 jugadores, 30 minutos, sin balones suficientes o grupo alterado. Nunca más llegarás al pabellón sin respuesta.'
}];
export function BonusesDetail() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-33" data-mp="2a8bq3pkvdct8">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-34" data-mp="258foty3k3zhd">
        <SectionTag icon="🎁" data-id="element-35" data-mp="2574l1ya42rq9">5 Bonos estratégicos incluidos</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-36" data-mp="26qwffz30081p">
          Y además, recibes 5 bonos exclusivos.
        </h2>
        <p className="mt-4 text-base text-muted sm:text-lg" data-id="element-37" data-mp="1xpg2pkopntub">
          Valor total de los bonos: <span className="text-white line-through" data-id="element-38" data-mp="22nrc5ub3g2c0">59,50€</span> →{' '}
          <span className="font-semibold text-success" data-id="element-39" data-mp="22q42ovux3l0o">Hoy: GRATIS con el Kit</span>
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-4xl gap-4 px-4 sm:px-6" data-id="element-40" data-mp="1nxad2hlxloia">
        {bonuses.map((bonus, i) => <m.div key={bonus.title} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.06
      }} className="flex flex-col gap-4 rounded-2xl border border-white/10 bg-bg-primary p-6 sm:flex-row sm:items-start" data-id="element-41" data-mp="1eyf8f9yjcmh3" data-mpi={i}>
            <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-orange/10 text-2xl" data-id="element-42" data-mp="19ykj3aues4y5">
              <span aria-hidden="true" data-id="element-43" data-mp="leh1z62hywxv">{bonus.emoji}</span>
            </div>
            <div className="flex-1" data-id="element-44" data-mp="lgadayo225c7">
              <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-45" data-mp="10bgk3nuz686l">
                <h3 className="font-heading text-base font-semibold text-white sm:text-lg" data-id="element-46" data-mp="vcn1xi4qtt03">{bonus.title}</h3>
                <span className="text-sm" data-id="element-47" data-mp="19c4vsbwwbwgb">
                  <span className="text-muted line-through" data-id="element-48" data-mp="19b3h7xgo8rtu">{bonus.value}</span>{' '}
                  <span className="font-semibold text-success" data-id="element-49" data-mp="14ca6udwolgxw">GRATIS</span>
                </span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-50" data-mp="1j1ogln4660dt">{bonus.text}</p>
            </div>
          </m.div>)}
      </div>

      <div className="mx-auto mt-6 max-w-2xl px-4 text-center sm:px-6" data-id="element-51" data-mp="1s2w2t6tevarj">
        <p className="rounded-xl border border-success/20 bg-success/5 px-5 py-4 text-sm font-medium text-white sm:text-base" data-id="element-52" data-mp="1s35vx39r5y1g">
          Si compras estos 5 bonos por separado: <span className="line-through text-muted" data-id="element-53" data-mp="3hj032nhqzf8a">59,50€</span> →{' '}
          <span className="text-success" data-id="element-54" data-mp="3miuowcmo1emh">Incluidos sin coste adicional</span>
        </p>
      </div>
    </section>;
}